import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import './RestaurantProject.css'
import FlickSnapshot from '../../assets/restaurants/home.png'

function Restaurant() {
  return (
    <div className="RestaurantProject">
        <img className="RestaurantProject_image" src={FlickSnapshot}/>
        <Link to="projects/restaurant"><button className="button paragraph--2">Fund Restaurants</button></Link>
    </div>
  )
}

export default Restaurant